import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { routes } from "./routes";
import "./styles/tailwind.css";

const router = createBrowserRouter(routes);

startTransition(() => {
  hydrateRoot(
    document.getElementById("root"),
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
});
